import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { ShoppingCart, CreditCard, Plus } from "lucide-react";

interface CreditPackagesProps {
  onBuyCredits: (amount: number) => void;
}

interface CreditPackage {
  credits: number;
  price: number;
  description: string;
  popular?: boolean;
}

export const CreditPackages = ({ onBuyCredits }: CreditPackagesProps) => {
  const packages: CreditPackage[] = [
    {
      credits: 1000,
      price: 49,
      description: "Perfect for small projects",
    },
    {
      credits: 5000,
      price: 199,
      description: "Most popular choice",
      popular: true,
    },
    {
      credits: 10000,
      price: 349,
      description: "Best value for large projects",
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-6">
        <CreditCard className="h-6 w-6" />
        <h2 className="text-2xl font-semibold">Additional Credits</h2>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {packages.map((pkg) => (
          <Card key={pkg.credits} className={pkg.popular ? "border-primary shadow-lg" : ""}>
            <CardHeader>
              <CardTitle>{pkg.credits.toLocaleString()} Credits</CardTitle>
              <CardDescription>{pkg.description}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold mb-2">${pkg.price}</div>
              <ul className="space-y-2 mb-4">
                <li className="flex items-center gap-2">
                  <Plus className="h-4 w-4 text-green-500" />
                  <span>{pkg.credits.toLocaleString()} additional credits</span>
                </li>
                <li className="flex items-center gap-2">
                  <Plus className="h-4 w-4 text-green-500" />
                  <span>Never expires</span>
                </li>
              </ul>
            </CardContent>
            <CardFooter>
              <Button 
                className="w-full" 
                onClick={() => onBuyCredits(pkg.credits)}
                variant={pkg.popular ? "default" : "outline"}
              >
                <ShoppingCart className="mr-2 h-4 w-4" />
                Buy Now
              </Button>
            </CardFooter>
          </Card>
        ))}
      </div>
    </div>
  );
};